import { GlobalContextType } from "./types";

const STORAGE_KEY = "zenith_session_context";

type PersistedSession = {
  signUp: {
    countryCode: string;
    phoneNumber: string;
    userExternalId: string;
  };
  mobileVerification: GlobalContextType["mobileVerificationContext"];
  outletSelection: GlobalContextType["outletContext"]["selection"];
};

export const hydrateGlobalContext = (
  init: GlobalContextType
): GlobalContextType => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return init;
    const persisted = JSON.parse(raw) as Partial<PersistedSession>;
    return {
      ...init,
      signUpContext: {
        ...init.signUpContext,
        ...persisted.signUp,
      },
      mobileVerificationContext: {
        ...init.mobileVerificationContext,
        ...persisted.mobileVerification,
      },
      outletContext: {
        ...init.outletContext,
        selection: persisted.outletSelection ?? init.outletContext.selection,
      },
    };
  } catch {
    return init;
  }
};

export const persistGlobalContext = (context: GlobalContextType): void => {
  try {
    const { countryCode, phoneNumber, userExternalId } = context.signUpContext;
    const toStore: PersistedSession = {
      signUp: { countryCode, phoneNumber, userExternalId },
      mobileVerification: context.mobileVerificationContext,
      outletSelection: context.outletContext.selection,
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(toStore));
  } catch {
    // Storage unavailable (private browsing, quota, etc.) — the session
    // just won't survive a reload, same as before this change.
  }
};
